import { lighten, parseToRgb, rgba } from 'polished';
import styled, { css } from 'styled-components';

export const FileUploadForm = styled.form`
  max-width: 100%;
  max-height: 50%;
  text-align: center;
  position: relative;
  overflow-x: hidden;
`;

export const FileUploadInput = styled.input`
  display: none;
`;

export const FileUploadBrowse = styled.a`
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  text-decoration: underline;
  &:hover {
    color: ${({ theme }) => theme.COLORS.TERTIARY};
    background-color: ${({ theme }) => lighten(0.2, theme.COLORS.TERTIARY)};
    opacity: 50%;
    cursor: pointer;
  }
`;

const StyledFileUploadVariants = {
  'drag-active': css`
    background-color: ${({ theme }) => {
      const rgb = parseToRgb(lighten(0.2, theme.COLORS.TERTIARY));
      rgb.alpha = 0.09;
      return rgba(rgb);
    }};
  `
};

export const FileUploadInputLabel = styled.label`
  height: 16em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: 1rem;
  border-style: dashed;
  border-color: #cbd5e1;
  margin-bottom: 20px;
  overflow-x: hidden;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  ${({ variant }) => StyledFileUploadVariants[variant]}
`;

export const FileUploadInputLabelSpan = styled.span`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const FileUploadDragArea = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
